// extracted by mini-css-extract-plugin
module.exports = {"tab_bar":"styles_tab_bar__2GtLa"};